export default {
  home: {
    hello: 'Hej',
    newMessage: 'Du har ett nytt meddelande!',
    newMessages: 'Du har nya meddelanden!',
    digitalHealthConsultationTitle: 'Digitalt hälsosamtal',
    viewBookingDetails: 'Se bokningsdetaljer',
    healthPlanTitle: 'Din individuella hälsoplan',
    digDeeperTitle: 'Utforska',
    discoverMore: 'Upptäck mer',
    podcastTitle: 'Missa inte vår podd - Gynpodden',
    podcastDescription:
      'I Gynpodden pratar vi om kvinnokroppen och jämställdhet utifrån ett vetenskapligt perspektiv. Personliga historier varvas med ämnen där vi bjuder in Sveriges främsta experter för att tillsammans sprida kunskap.',
    allPodcastEpisodes: 'Till alla våra gynpoddenavsnitt',
    messageQuestion: 'Har du frågor om din hälsa eller hälsoplan?',
    messageTitle: 'Skriv till EsterCares hälsoteam',
    messageDescription:
      'Har du frågor om din hälsa eller hälsoplan? Skriv till EsterCares hälsoteam och få individuell vägledning när du behöver det. Ingen fråga är för liten – vi finns här för att stötta dig. Vårt hälsoteam svarar vanligtvis inom 24 timmar på vardagar.',
  },
  healthCall: {
    callsRemaining: 'Du har {{count}}/{{total}} digitala hälsosamtal kvar att använda.',
    step1Title: 'Boka ett hälsosamtal',
    step1Description:
      'Börja med att fylla i dina uppgifter och välj därefter en tid som passar dig. När bokningen är genomförd skickas en bekräftelse till din e-post.',
    goToCalendar: 'Välj tid för hälsosamtal',
    journalText:
      'Hälsosamtalet bokas i vårt journalsystem och dina uppgifter hanteras där enligt patientdatalagen. Din arbetsgivare har aldrig tillgång till dem.',
    journalCheckbox: 'Jag har tagit del av informationen och vill boka hälsosamtalet.',
    journalConsentError: 'Något gick fel när ditt godkännande skulle sparas. Försök igen senare.',
    step2Title: 'Ladda ner vår app',
    step2Description:
      'Sök på "EsterCare" i App Store eller Google Play eller skanna QR-koden för att ladda ner EsterCare-appen direkt:',
    step3Title: 'Logga in och genomför ditt samtal',
    step3Description:
      'Du loggar enkelt in i vår app med ditt BankID och genomför sedan samtalet i EsterCare-appen. Du kan ansluta till mötet 5 minuter innan din bokade tid.',
    completedTitle: '{{total}} av {{total}} hälsosamtal genomförda',
    completedDescription:
      'Du har genomfört dina tre hälsosamtal som bekostats av {{organisationName}}. Du får tillgång till ytterligare tre samtal nästa år.',
    howToPerform: 'Hur genomför jag hälsosamtalet?',
    modalTitle: 'Dina uppgifter',
    modalDescription: 'Fyll i dina uppgifter så återkommer vi till dig med en bokningsbekräftelse inom kort.',
    errorMessage: 'Något gick fel, vänligen kontrollera att dina uppgifter är korrekta.',
    personalNumber: 'Personnummer',
    phoneNumber: 'Telefonnummer',
    phoneNumberPlaceholder: '+4670XXXXXXX',
    personalNumberPlaceholder: 'ÅÅÅÅMMDD-XXXX',
    personalNumberValidationError: 'Ange i formatet ÅÅÅÅMMDD-XXXX',
    personalNumberRequired: 'Personnummer krävs',
    phoneNumberValidationError: 'Ogiltigt telefonnummer. Måste vara i formatet: +46701234567',
    phoneNumberRequired: 'Telefonnummer krävs',
    bookingInfo: 'Digitalt videomöte - logga in i EsterCare-appen för att genomföra mötet',
    bookingDetails: 'Dina bokningsdetaljer',
    cancelWarning:
      'Om du avbokar ditt hälsosamtal inom 24 timmar före bokad tid räknas det som ett genomfört hälsosamtal.',
    cancelError: 'Det gick inte att avboka ditt hälsosamtal. Vänligen försök igen eller kontakta support.',

    cancelBooking: 'Avboka ditt hälsosamtal',
    cancelConfirmation: 'Är du säker på att du vill avboka?',
    todayAt: 'Idag kl.',
    tomorrowAt: 'Imorgon kl.',
    time: 'kl.',
    calendarTitle: 'Digitalt hälsosamtal',
    calendarDescription:
      'Boka ett videosamtal med en av våra barnmorskor för att få personlig rådgivning och stöd kring din hälsa.',
    confirmBooking: 'Bekräfta bokning',
    fullyBooked: 'Fullbokat',
    loading: 'Laddar tider...',
    error: 'Ett fel uppstod',
    timeSlotErrorMessage: 'Kunde inte ladda tillgängliga tider. Försök igen.',
    duration: '15 min',
    meetingType: 'Digitalt videosamtal',
    confirmTitle: 'Bekräfta din bokning',
    cancellationPolicy:
      'Du kan avboka eller boka om ditt hälsosamtal senast 24 timmar innan mötet. Vid uteblivet möte eller avbokning senare är 24 timmar innan räknas det som ett förbrukat hälsosamtal.',
    bookingError: 'Det gick inte att boka hälsosamtalet. Vänligen försök igen.',
    timeslotExpired: 'Tiden är inte längre tillgänglig',
    timeslotExpiredMessage:
      'Den valda tiden har tyvärr passerat eller är inte längre bokningsbar. Vänligen välj en ny tid.',
    timeslotExpiredButton: 'Välj ny tid',
    cancelSuccess: 'Ditt hälsosamtal har avbokats.',
    cancelSuccessTitle: 'Bokning avbokad',
    cancelSuccessMessage: 'Ditt hälsosamtal har avbokats.',
    notAvailableTitle: 'Tjänsten är inte tillgänglig',
    notAvailableMessage: 'Hälsosamtal är för närvarande inte tillgängliga för användare i denna marknad.',
    returnToHome: 'Tillbaka till startsidan',
  },
  screening: {
    basedOnDate: 'Baserat på din screening från {{date}}',
    recommendationsHelperText:
      'Behöver du fräscha upp minnet lite? Här kan du läsa igenom de råd vi gav kring egenvård i hälsoplanen.',
    showRecommendations: 'Visa dina rekommendationer',
    hideRecommendations: 'Dölj dina rekommendationer',
    followUpDescription:
      'Nu är det dags att följa upp för att se hur de senaste månaderna har varit och hur du mår idag.\n\nDina svar hjälper oss att ge dig mer relevanta rekommendationer framåt och uppdatera graferna över ditt mående för att du ska kunna följa hur din hälsa utvecklas över tid.\n\nUppföljningen tar cirka 5 minuter att genomföra.',
    standardDescription:
      'Genom att svara på screeningfrågor hjälper vi dig att identifiera besvär som påverkar din hälsa. Du får en personlig analys och en handfast hälsoplan som kan hjälpa dig att ta nästa steg mot ett bättre välmående. Dina svar är konfidentiella och delas inte med {{organisationName}}.\n\nScreeningen tar cirka 15 minuter att genomföra.',
    invitedStandardDescription:
      'Genom att svara på screeningfrågor hjälper vi dig att identifiera besvär som påverkar din hälsa. Du får en personlig analys och en handfast hälsoplan som kan hjälpa dig att ta nästa steg mot ett bättre välmående. Dina svar är konfidentiella.\n\nScreeningen tar cirka 15 minuter att genomföra.',
    invitedFollowUpDescription:
      'Det är nu dags att följa upp hur du mår baserat på de svar du gav i screeningen i {{date}}.\n\nGenom att besvara frågorna i uppföljningen kan vi se om dina besvär har förbättrats eller inte, och du får uppdaterade råd i retur. Dina svar är konfidentiella.\n\nUppföljningen tar cirka 2 minuter att genomföra.',
    submitTitle: 'Dags att skicka in!',
    submitButton: 'Skicka in',
    submitPreviousError:
      'Det gick inte att gå till föregående fråga. Vänligen försök igen eller kontakta support på support@estercare.com',
    submitError:
      'Det gick inte att skicka in screeningen. Vänligen försök igen eller kontakta support på support@estercare.com',
    errorTitle: 'Någonting gick fel!',
    nextQuestionError:
      'Det gick inte att gå till nästa fråga. Vänligen försök igen eller kontakta support på support@estercare.com',
    previousQuestionError:
      'Det gick inte att gå till föregående fråga. Vänligen försök igen eller kontakta support på support@estercare.com',
    generalError: 'Något gick fel. Försök igen!',
    continueButton: 'Fortsätt',
    nextQuestionButton: 'Nästa fråga',
    standardTitle: 'Screeningtjänst för kvinnohälsa',
    standardNotStartedPage: 'Påbörja screening',
    standardContinuePage: 'Fortsätt med screeningen',
    standardNotStartedButton: 'Påbörja screening',
    standardContinueButton: 'Fortsätt med screeningen',
    standardCompletedTitle: 'Din screening är hanterad!',
    standardCompletedDescription: 'Ta del av din personliga analys och hälsoplan under Din hälsoplan.',
    standardCompletedButton: 'Gå till din hälsoplan',
    standardCompletedPending: 'Din screening hanteras',
    standardPendingDescription:
      'Din screening är inskickad och hanteras just nu av våra experter. Inom 3 vardagar får du ett mail när din personliga analys och hälsoplan är klar.',
    consentAgree:
      'Jag samtycker till att EsterCare behandlar mina hälsouppgifter för screening, hälsoplan, uppföljning och meddelanden enligt',
    dataProcessing: 'dataskyddspolicyn',
    consentWithdraw: '. Jag kan återkalla samtycket när som helst.',
    journalTitle: 'Spara din screening inför vårdbesök (frivilligt).',
    journalText:
      'Vi sparar en sammanfattning av din screening i vårt journalsystem, så att läkaren kan läsa den om du senare bokar ett läkarbesök hos oss. Det kräver ditt personnummer. Sammanfattningen hanteras enligt patientdatalagen och din arbetsgivare har aldrig tillgång till den.',
    journalCheckbox: 'Ja, spara en sammanfattning av min screening i journalsystemet.',
    consentError: 'Något gick fel när samtycket skulle sparas. Försök igen senare.',
    followUpTitle: 'Uppföljning av din screening',
    followUpNotStartedPage: 'Påbörja uppföljning',
    followUpContinuePage: 'Fortsätt med uppföljningen',
    followUpNotStartedButton: 'Påbörja uppföljning',
    followUpContinueButton: 'Fortsätt med uppföljningen',
    followUpCompletedPage: 'Uppföljning',
    followUpCompletedTitle: 'Din uppföljning är hanterad!',
    followUpCompletedDescription: 'Ta del av din personliga analys och hälsoplan under Din hälsoplan.',
    followUpCompletedButton: 'Gå till Din hälsoplan',
    followUpPendingPage: 'Din uppföljning hanteras',
    followUpPendingTitle: 'Din uppföljning hanteras',
    followUpPendingDescription:
      'Din uppföljning är inskickad och hanteras just nu av våra experter. Inom 3 vardagar får du ett mail när din personliga analys och hälsoplan är uppdaterad.',
    checkInTitle: 'Hej {{firstName}}!',
    checkInDescription: 'I {{date}} gjorde du en screening, hur har det gått sedan dess?',
    outcomesTitle: 'Dina utfall baserat på din screening från {{date}}',
    outcomesDescription: 'I din screening identifierades följande områden, det är dessa vi vill följa upp idag.',
    checkInNotStartedPage: 'Incheckning',
    checkInNotStartedButton: 'Påbörja incheckning',
    checkInContinuePage: 'Incheckning',
    checkInContinueButton: 'Fortsätt incheckning',
    bookHealthCallPage: 'Hälsosamtal',
    bookHealthCallTitle: 'Vill du boka ett hälsosamtal?',
    bookHealthCallDescription:
      'Under ett hälsosamtal får du träffa en barnmorska digitalt och gå igenom resultatet från din screening. Du har också möjlighet att ställa frågor om ditt mående och vid behov bli inbokad på ett vårdmöte.',
    bookHealthCallButton: 'Boka hälsosamtal',
    under15Warning: 'Du får åtkomst till screeningen från och med det år du fyller 15.',
    maleUserTitle: 'Här kan kvinnliga användare starta sin screening.',
    maleUserDescription: 'Du har uppgett att ditt biologiska kön är man.',
    giftHeading: 'Ge bort en screening i kvinnohälsa',
    giftDescription:
      'Vår screening är utvecklad för att ge kvinnor personliga insikter och konkreta rekommendationer kring sin hälsa.\n\nSom man har du möjlighet att ge bort en screening med tillhörande hälsoplan till någon du bryr dig om – till exempel en partner, syster, dotter eller vän.\n\nDet tar bara någon minut att skicka en inbjudan och kan göra stor skillnad för någons hälsa.',
    giftButton: 'Ge bort en screening',
    giftModalTitle: 'Ge bort en screening',
    maleScreeningTitle: 'Screeningtjänst',
    giftModalDescription: 'Skicka en inbjudan till EsterCares hälsoportal.\nKontot är helt separat från ditt.',
    giftFirstName: 'Förnamn',
    giftLastName: 'Efternamn',
    giftEmail: 'E-post',
    giftSendButton: 'Skicka inbjudan',
    giftSuccessTitle: 'Inbjudan skickad!',
    giftSuccessDescription: 'En inbjudan har skickats till {{email}}.',
    giftAlreadyInvited: 'Du har redan skickat en inbjudan.',
    giftError: 'Något gick fel när inbjudan skulle skickas. Försök igen.',
    renewScreeningTitle: 'Dags för en ny screening!',
    renewScreeningDescription:
      'Nu har det gått ett år sedan du gjorde din senaste screening. Vi rekommenderar att du gör screeningen på nytt så att vi kan fortsätta ge dig relevanta råd och rekommendationer.',
    renewScreeningButton: 'Starta screening',
    previousRating: 'Senast skattade du {{rating}} av {{max}}',
  },
  yourHealth: {
    summary: 'Sammanfattning',
    wellbeing: 'Ditt mående',
    overallWellbeingScore: 'Ditt allmänna mående',
    symptomTrendsTitle: 'Symtomtrender över tid',
    symptomTrendsDescription:
      'Följ hur enskilda symtom förändras mellan screeningar för att bättre förstå hur ditt mående utvecklas över tid.',
    topSymptomsOverview: 'Översikt av dina främsta symtom',
    graphsBreakdownTitle: 'Din hälsa i detalj',
    graphsBreakdownDescription: 'Se hur dina symtom och ditt mående utvecklas och påverkar din vardag.',
    severity: 'Svårighetsgrad',
    everydayImpact: 'Påverkan på vardagen',
    trackMoodTitle: 'Följ ditt mående över tid',
    trackMoodDescription:
      'När du genomför våra screeningar kan du följa ditt mående över tid. Det kan skapa en förståelse för hur ditt mående och dina besvär förändras och om rekommendationerna från hälsoplanen hjälper.',
    generalMood: 'Allmänt mående',
    moreStatsText: 'Här kommer mer statistik visas framöver så att du kan följa hur dina besvär förändras över tid.',
    analysisTab: 'Din analys',
    healthPlanTab: 'Hälsoplan',
    healthProgressTab: 'Hälsa över tid',
    noScreeningDescription:
      'Här hittar du din personliga hälsoplan.\nI hälsoplanen hjälper vi dig att identifiera eventuella problemområden, förebygga framtida besvär och stärka din hälsa.\nFör att vi ska kunna skapa den behöver du först genomföra vår screening.',
    pendingMessage:
      'När du har genomfört din screening och vi har analyserat dina svar kommer din personliga hälsoplan visas här. Analysen kan ta upp till 3 vardagar.',
    promptStartTitle: 'Dags att göra din hälsoscreening',
    promptStartDescription:
      'Genom att svara på screeningfrågor hjälper vi dig att identifiera besvär som påverkar din hälsa. Du får en personlig analys och en skräddarsydd hälsoplan.',
    promptStartButton: 'Påbörja screening',
    promptContinueTitle: 'Slutför din hälsoscreening',
    promptContinueDescription: 'Du har påbörjat din screening. Slutför den för att få din personliga hälsoplan.',
    promptContinueButton: 'Fortsätt screening',
    promptFollowUpStartTitle: 'Dags för din uppföljning',
    promptFollowUpStartDescription:
      'Det är nu dags att följa upp hur du mår baserat på dina tidigare svar. Genom uppföljningen kan vi se om dina besvär har förbättrats.',
    promptFollowUpStartButton: 'Påbörja uppföljning',
    promptFollowUpContinueTitle: 'Slutför din uppföljning',
    promptFollowUpContinueDescription:
      'Du har påbörjat din uppföljning. Slutför den för att få uppdaterade rekommendationer.',
    promptFollowUpContinueButton: 'Fortsätt uppföljning',
    healthPlanSummary: 'Din hälsoplan i korthet',
    careContactInfo: 'Om du behöver söka vård för dina besvär kan du kontakta:',
    gynecologyInfo:
      'En gynekologmottagning. Observera att det i vissa regioner krävs en remiss för att komma till gynekolog, medan du i andra regioner kan boka tid direkt. Gå in på 1177 för information om vad som gäller där du bor.',
    physicalClinicInfo:
      'EsterCares fysiska mottagning. För ett fysiskt besök hos en gynekolog i Stockholm kan du boka tid på vår gynmottagning på Torsplan. Det gör du genom att ringa till 08-60 90 270. Vår mottagning är regionsansluten, vilket innebär att du betalar en patientavgift på 275 kr, frikort gäller.',
    digitalClinicInfo:
      'EsterCares digitala mottagning. Du kan boka ett digitalt besök hos en gynekolog via vår EsterCare-app. Vår mottagning är regionsansluten, vilket innebär att du betalar en patientavgift på 100 kr för ett digitalt besök, frikort gäller.',
    readMoreHere: 'Läs mer här.',
    helloGreeting: 'Hej, {{firstName}}!',
    readHealthPlan: 'Läs din hälsoplan',
    meetTeamTitle: 'Möt teamet bakom din hälsoplan',
    healthPlanCardsTitle: 'Dina rekommendationer',
    healthPlanCardsDescription:
      'Råd och rekommendationer inom kost, träning, stresshantering, psykiskt välmående, sömn och livsstil – anpassade efter dina behov.',
    needHealthCare: 'Behöver du söka vård?',
    gynocologistOfficeTitle: 'Gynekologmottagning',
    gynocologistOfficeDescription:
      'Observera att det i vissa regioner krävs en remiss för att komma till gynekolog, medan du i andra regioner kan boka tid direkt. Gå in på 1177 för information om vad som gäller där du bor.',
    physicalClinicTitle: 'EsterCares fysiska mottagning',
    physicalClinicDescription:
      'För ett fysiskt besök hos en gynekolog i Stockholm kan du boka tid på vår gynmottagning på Torsplan. Det gör du genom att ringa till 08-60 90 270. Vår mottagning är regionsansluten, vilket innebär att du betalar en patientavgift på 275 kr, frikort gäller.',
    digitalClinicTitle: 'EsterCares digitala mottagning',
    digitalClinicDescription:
      'Du kan boka ett digitalt besök hos en gynekolog via vår EsterCare-app. Vår mottagning är regionsansluten, vilket innebär att du betalar en patientavgift på 100 kr för ett digitalt besök, frikort gäller.',
    learnMore: 'Läs mer',
    yourOutcomes: 'Dina utfall',
    yourOutcomesDescription:
      'Baserat på din screening har vi identifierat följande utfall som kan vara relevanta för dig.',
    yourWellbeingTitle: 'Ditt mående över tid',
    yourCheckList: 'Din checklista',
    translationsMissing1:
      'En översättning av din hälsoplan är för närvarande ofullständig eller inte tillgänglig på det språk du har valt. Vänligen kontakta supporten för hjälp.',
    translationsMissing2:
      'Om du nyligen har ändrat dina språkinställningar kan det ta några minuter innan allt innehåll har uppdaterats. Försök att uppdatera sidan om en liten stund.',
    showLess: 'Visa mindre',
    askUs: 'Chatta med oss',
    askUsHeader: 'Chatt',
    askUsTitle: 'Ditt hälsoteam finns här för dig',
    askUsDescription:
      'Ställ frågor, dela funderingar eller få vägledning kring din hälsoplan och ditt välbefinnande. Ingen fråga är för liten – vi finns här för att stödja dig.',
    askUsCta: 'Starta en konversation',
    followUpUpdated: 'Uppdaterade rekommendationer!',
    followUpUpdatedDate: 'Baserat på din uppföljning i {{date}}',
    followUpSummaryUpdated: 'Vi har uppdaterat din analys – läs din nya sammanfattning här',
    improvedInAreas_one: '{{count}} område har förbättrats',
    improvedInAreas_other: '{{count}} områden har förbättrats',
    areaStable_one: '{{count}} område är stabilt',
    areaStable_other: '{{count}} områden är stabila',
    needsAttention_one: '{{count}} område att se över',
    needsAttention_other: '{{count}} områden att se över',
    yourProgress: 'Din utveckling',
    progressVs: 'jmf. {{date}}',
    seeAllProgress: 'Se hela din utveckling, grafer och skattningar här',
    symptomImproving: 'Förbättrat',
    symptomStable: 'Stabilt',
    symptomNeedsAttention: 'Försämrat',
    symptomResolved: 'Åtgärdat',
  },
  submitScreen: {
    followUpTitle: 'Skicka in uppföljning',
    followUpSuccessTitle: 'Din uppföljning är inskickad!',
    followUpInstructions: 'Nu har du svarat på alla frågor och det återstår bara att skicka in uppföljningen.',
    followUpProcess:
      'Vad händer nu? Vårt team kommer gå igenom dina svar för att bedöma hur ditt mående har utvecklats och sammanställa individuella rekommendationer baserat på dina behov. Inom 3 arbetsdagar får du ett mail om att analysen är redo.',
    checkInTitle: 'Skicka in incheckning',
    checkInSuccessTitle: 'Din incheckning är inskickad!',
    checkInInstructions: 'Du är nu klar med din incheckning, skicka in dina svar.',
    screeningTitle: 'Skicka in screening',
    screeningSuccessTitle: 'Din screening är inskickad!',
    screeningInstructions: 'Nu har du svarat på alla frågor och det återstår bara att skicka in screeningen.',
    screeningProcess:
      'Vad händer sen? Vårt hälsoteam kommer börja arbeta på din personliga analys och hälsoplan. Inom 3 vardagar kommer du få mail om att dina resultat är färdiga - vi är övertygade om att du kommer vilja ta nästa steg på din hälsoresa!',
    endFollowUpNoBookingRequest:
      'Tack för dina svar! Vi återkopplar inom tre vardagar med uppdaterade råd och rekommendationer i din hälsoplan. Redan nu kan du följa hur din hälsa har utvecklats över tid.',
    endFollowUpBookingRequest:
      'Tack för dina svar! Vi återkopplar inom tre vardagar med uppdaterade råd och rekommendationer i din hälsoplan. Eftersom du önskade hjälp med att boka ett vårdmöte kan du skicka en bokningsförfrågan redan nu. Vi återkommer sedan så snart som möjligt med ett förslag på en tid för antingen ett fysiskt eller digitalt möte.',
    endFollowUpPregnancyEnded:
      'Tack för dina svar! Vi ser att din situation har förändrats sedan du gjorde din screening förra gången. Vill du göra om din screening i sin helhet och få en uppdaterad hälsoplan?',
    endCheckInNoBookingNoCall:
      'Tack för dina svar! Nu är den här kortare incheckningen klar. Vi återkommer till dig när det är dags för en mer omfattande uppföljning av ditt mående. Då kommer du att få registrera dina symtom och därefter få nya, uppdaterade rekommendationer. Vill du prata med en barnmorska redan nu? Boka ett kostnadsfritt hälsosamtal där du kan ställa frågor och få råd, stöd och vägledning kring din hälsa.',
    endCheckInNoBookingRequestHasCall:
      'Tack för dina svar! Nu är den här kortare incheckningen klar. Vi återkommer till dig när det är dags för en mer omfattande uppföljning av ditt mående. Då kommer du att få registrera dina symtom och därefter få nya, uppdaterade rekommendationer. Har du några frågor om din hälsoplan eller ditt mående? Då kan du chatta med EsterCares hälsoteam för att få snabbt svar på dina frågor.',
    endCheckInBookingRequest:
      'Tack för dina svar! Nu är den här kortare incheckningen klar. Vi återkommer till dig när det är dags för en mer omfattande uppföljning av ditt mående. Då kommer du att få registrera dina symtom och därefter få nya, uppdaterade rekommendationer. Eftersom du önskade hjälp med att boka ett vårdmöte kan du skicka en bokningsförfrågan redan nu. Vi återkommer sedan så snart som möjligt med ett förslag på en tid för antingen ett fysiskt eller digitalt möte.',
    endStandardBookingRequest:
      'Tack för dina svar! Vårt hälsoteam kommer börja arbeta på din personliga analys och hälsoplan. Inom 3 vardagar kommer du få mail om att dina resultat är färdiga. Eftersom du önskade hjälp med att boka ett vårdmöte kan du skicka en bokningsförfrågan redan nu. Vi återkommer sedan så snart som möjligt med ett förslag på en tid för antingen ett fysiskt eller digitalt möte.',
    endBookingRequestButton: 'Skicka förfrågan om vårdmöte',
    endCheckInNoBookingNoCallButton: 'Boka hälsosamtal med en barnmorska',
    endStartConversationButton: 'Chatta med en barnmorska',
    endFollowUpNoBookingRequestButton: 'Se din hälsoutveckling',
    endFollowUpPregnancyEndedButton: 'Starta ny screening',
    endTitle: 'Tack för dina svar!',
  },
  trainings: {
    title: 'Utbildning',
    description:
      'Utbildning inom kvinnohälsa är avgörande för att öka medvetenheten om kvinnors unika hälsobehov. Genom ökad kunskap kan vi minska stigmat, förbättra arbetsmiljöer och främja en mer inkluderande och hälsosam organisation.',
    completedMessage: 'Du har genomfört utbildningen',
  },
  support: {
    questionsTitle: 'Har du andra frågor?',
    contactText: 'Maila till support@estercare.com så hjälper vi dig!',
  },
  messages: {
    title: 'Chatt',
    startConversation: 'Starta en ny konversation',
    emptyTitle: 'Ditt hälsoteam finns här för dig',
    emptyDescription:
      'Ställ frågor, dela tankar eller få vägledning kring din hälsoplan och ditt välmående. Ingen fråga är för liten, vi finns här för dig. Vårt hälsoteam svarar vanligtvis inom 24 timmar på vardagar.',
    topicsLabel: 'Exempel på vad du kan fråga om',
    topicDiet: 'Kost',
    topicSleep: 'Sömn',
    topicStress: 'Stresshantering',
    topicMentalHealth: 'Psykiskt välmående',
    topicOutcomes: 'Hälsoplanens utfall',
    topicDetails: 'Hälsoplanens detaljer',
    topicSelfCare: 'Egenvård',
    messageLabel: 'Ditt meddelande',
    messagePlaceholder: 'Beskriv dina frågor eller funderingar...',
    bookingRequestTemplate:
      'Hej, jag skulle vilja få hjälp med att boka ett vårdmöte efter att ha genomfört screeningen.\n\nMitt personnummer: \nMitt telefonnummer: ',
    sendButton: 'Skicka ditt meddelande',
    replyTime:
      'Dina frågor hanteras konfidentiellt och besvaras av legitimerad vårdpersonal. Vi svarar vanligtvis inom 24 timmar på vardagar.',
    healthTeam: 'EsterCare Hälsoteam',
    responseInfo: 'Legitimerad vårdpersonal svarar dig inom 24 timmar. Du får en notifikation via e-post.',
    writeMessage: 'Skriv ditt meddelande...',
    tableHeaderId: 'Meddelande',
    tableHeaderStatus: 'Status',
    tableHeaderLastMessageDate: 'Senast uppdaterad',
    closedCase: 'Avslutat',
    relativeTimeJustNow: 'Just nu',
    relativeTimeMinutesAgo: 'm sen',
    relativeTimeHoursAgo: 'h sen',
    relativeTimeYesterday: 'Igår',
    relativeTimeDaysAgo: 'dagar sen',
    fallbackSender: 'Du:',
    selectConversationFooter:
      'Har du frågor om EsterCare? Kolla in våra <highlight>vanliga frågor och svar</highlight>.',
    createError: 'Något gick fel, försök igen lite senare.',
    conversationClosedTitle: 'Konversationen är avslutad.',
    conversationClosedDescription:
      'Du kan alltid starta en ny konversation om du har fler frågor eller behöver ytterligare hjälp.',
  },
  knowledgeBank: {
    articlesCount: 'Artiklar ({{count}})',
    podcastsCount: 'Poddavsnitt ({{count}})',
    allPodcasts: 'Alla poddavsnitt',
    allArticles: 'Alla artiklar',
    episodeTitle: 'Avsnitt {{episodeNumber}}: {{title}}',
    aboutEpisode: 'Om avsnittet',
    relatedPodcasts: 'Relaterade Poddar',
    relatedArticles: 'Relaterade artiklar',
    swedishOnly: 'Detta poddavsnitt är på svenska.',
  },
} as const
